export default __webpack_public_path__ + "static/media/tailwind_zeus.cac97ef6.svg";